@if (contextId) {
  <div
    id="section-updated"
    class="object-update-log information-tabs-table"
  >
    @if (finishedLoading) {
      @if (logItems.length) {
        <table
          mat-table
          [dataSource]="logItems"
        >
          @if (logItems.length) {
            <ng-container matColumnDef="updated_at">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'TRANS__FIELD__UPDATED_AT' | translate }}
              </th>

              <td mat-cell *matCellDef="let element">
                {{element['updated_at']}}
              </td>
            </ng-container>

            <ng-container matColumnDef="updated_by_id">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'TRANS__FIELD__UPDATED_BY' | translate }}
              </th>

              <td mat-cell *matCellDef="let element">
                {{element['updated_by_id']}}
              </td>
            </ng-container>
          }

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      }
      @else {
        <div>
          <span>
            {{ 'TRANS__OBJECT_UPDATE_LOG__NO_REGISTERED_CHANGES' | translate }}
          </span>
        </div>
      }
    }
    @else {
      <mat-spinner
        [diameter]="16"
        color="accent"
      ></mat-spinner>
    }
  </div>
}
